/* eslint-disable import/no-unresolved */
import React, { FC, useEffect, useRef } from 'react';
import useTranslation from 'next-translate/useTranslation';

import styles from './Search.module.scss';

interface IProps {
  onChange: (e: string) => void;
  value?: string;
}

const Search: FC<IProps> = ({ onChange, value }: any) => {
  const { t } = useTranslation();

  const inputEl = useRef(null);

  useEffect(() => {
    inputEl.current.focus();
  }, []);

  return (
    <form
      className={styles.searchInput}
      itemScope
      itemType='https://schema.org/Action'
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className='w-100 d-flex align-items-center'>
        <input
          data-testid={'search-input'}
          autoFocus={true}
          ref={inputEl}
          type='text'
          placeholder={t('esim:checkout.modals.devices.search')}
          value={value}
          className='w-100'
          onChange={(e: any) => {
            onChange(e.target.value);
          }}
          aria-label={value}
        />
      </div>
    </form>
  );
};

export default Search;
